import { FlexCenter } from "@opensea/ui-kit"
import { SocialLinks } from "@/components/social/SocialLinks"
import {
  DISCORD_URL,
  INSTAGRAM_USERNAME,
  TELEGRAM_USERNAME,
  X_USERNAME,
} from "@/constants/constants"

export function PageFooterSocialLinks() {
  return (
    <FlexCenter className="gap-3" color="text-secondary">
      <SocialLinks.Discord href={DISCORD_URL} size={16} />
      <SocialLinks.Telegram size={16} username={TELEGRAM_USERNAME} />
      <SocialLinks.Twitter size={16} username={X_USERNAME} />
      <SocialLinks.Instagram size={16} username={INSTAGRAM_USERNAME} />
    </FlexCenter>
  )
}
